/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsfeebuyer2Inputs */

const en_ticketsfeebuyer2 = /** @type {(inputs: Ticketsfeebuyer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buyer`)
};

const de_ticketsfeebuyer2 = /** @type {(inputs: Ticketsfeebuyer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Käufer`)
};

/**
* | output |
* | --- |
* | "Buyer" |
*
* @param {Ticketsfeebuyer2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsfeebuyer2 = /** @type {((inputs?: Ticketsfeebuyer2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsfeebuyer2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsfeebuyer2(inputs)
	return de_ticketsfeebuyer2(inputs)
});
export { ticketsfeebuyer2 as "ticketsFeeBuyer" }